import React from 'react'
import { FormattedMessage } from 'react-intl'

import { UNIT_TYPES } from 'constants'

export const BATTLE_LIST_CAPTIONS = {
    [UNIT_TYPES.SORTIE]: (
        <FormattedMessage
            id='battle_wizard.battle_list_captions.sortie'
            defaultMessage='Выберите дивизион'
        />
    ),
    [UNIT_TYPES.FORT_BATTLE]: (
        <FormattedMessage
            id='battle_wizard.battle_list_captions.fort_battles'
            defaultMessage='Выберите Плацдарм для битвы'
        />
    ),
}



// WEBPACK FOOTER //
// ./components/BattleWizard/components/Battle/constants.jsx